import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ServerError = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Helmet>
        <title>Server Error</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          py: 4,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: "8rem", fontWeight: "bold", color: "error.main" }}>
          500
        </Typography>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
          Server Error
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
          Something went wrong on our server. We're working to fix this issue.
          Please try again later or contact support if the problem persists.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => window.location.reload()}
            sx={{ minWidth: 120 }}
          >
            Try Again
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/")}
            sx={{ minWidth: 120 }}
          >
            Go Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ServerError;
